import React from "react";
import { Helmet } from "react-helmet";

const AppMetaTags = () => {
  return (
    <Helmet>
      <title>Mr ProFox | Virtual Conference, Real Life Experience!</title>
      <meta name="title" content="Mr ProFox | Virtual events, virtual networking!" />
      <meta name="description" content="" />

      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://mrprofox.com/" />
      <meta property="og:title" content="Mr ProFox | Virtual Conference, Real Life Experience!" />
      <meta property="og:description" content="" />
      <meta property="og:image" content="/DefaultEventBanner.png" />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://mrprofox.com/" />
      <meta property="twitter:title" content="Mr ProFox | Virtual Conference, Real Life Experience!" />
      <meta property="twitter:description" content="" />
      <meta property="twitter:image" content="/DefaultEventBanner.png" />
    </Helmet>
  )
}

export default AppMetaTags;
